import i18n from '../i18n/i18n-yuge-merchant-tool.json';

export function __(lang, key) {
  lang = lang.toLowerCase();
  if (i18n[lang] !== undefined && i18n[lang][key] !== undefined) {
    return i18n[lang][key];
  }
  return `__${key}__`;
}
